import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { IndicationTrayComponent } from './indication-tray/indication-tray.component';
import { SharedPipesModule, DialogsModule } from '@finders/finder';

@NgModule({
  declarations: [HeaderComponent, IndicationTrayComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    RouterModule,
	SharedPipesModule,
    DialogsModule
  ],
  exports: [HeaderComponent, IndicationTrayComponent]
})
export class HeaderModule {}
